import { computed } from "vue";
import { useI18n } from "vue-i18n";

const PRIVACY_LINK_DE = "https://quanos.com/datenschutz/#c16108";
const PRIVACY_LINK_EN = "https://quanos.com/en/privacy-policy/#c16111";

export const privacyPolicyLink = computed(() => {
    const { locale } = useI18n();
    if (locale.value === "de") {
        return PRIVACY_LINK_DE;
    } else {
        return PRIVACY_LINK_EN;
    }
});
